import type { DeviceDefinition } from "@medplum/fhirtypes";
import { CATALOG_VIEW_SCOPE } from "./catalog-view-scope";
import {
  deviceDefinitionAvailability,
  deviceDefinitionMintedAt,
  deviceDefinitionName,
  deviceDefinitionUrl,
  deviceDefinitionVersion,
} from "./device-definition-storage";
import type { DeviceDefinitionDerived } from "./types";

/**
 * Scalar storage columns used by TanStack DB to query current device revisions.
 *
 * `mintedAt` is read and discarded on purpose. The readers throw on an
 * unreadable row and `deriveForSync` drops it, so validating here is what keeps
 * the projection's `fn.select` — where a throw blanks the page instead of
 * costing one row — from ever meeting a row it cannot read.
 */
export function deriveDeviceDefinitionFields(resource: DeviceDefinition): DeviceDefinitionDerived {
  deviceDefinitionMintedAt(resource);
  return {
    catalogViewScope: CATALOG_VIEW_SCOPE,
    deviceDefinitionUrl: deviceDefinitionUrl(resource),
    deviceDefinitionVersion: deviceDefinitionVersion(resource),
    deviceDefinitionAvailability: deviceDefinitionAvailability(resource),
    deviceDefinitionName: deviceDefinitionName(resource),
  };
}
